import Vue from "vue";
import VueRouter from "vue-router";
import { getBasePath } from "../utils/env";
import { nameRoutes } from "./nameRoutes";
import { SISR_TOKEN } from "../../libs/utils/access/constants";

import BaseLayout from "../../pages/layouts/base";
import AccessLayout from "../../pages/layouts/access";

import Login from "../../pages/access/Login";

import Richieste from "../../pages/application/Richieste";
import Richiesta from "../../pages/application/Richiesta";
import Portata from "../../pages/application/Portata";
import NotFound from "../../pages/application/NotFound";
import Benvenuto from "../../pages/application/Benvenuto";

Vue.use(VueRouter);

const checkAuthorized = (to, from, next) => {
  if (!localStorage.getItem(SISR_TOKEN)) next("/login");
  else next();
};

const checkIfAlreadyLoggedIn = (to, from, next) => {
  if (localStorage.getItem(SISR_TOKEN)) next("/richieste");
  else next();
};

const routes = [
  {
    path: "/login",
    component: AccessLayout,
    children: [
      {
        beforeEnter: checkIfAlreadyLoggedIn,
        path: "",
        component: Login,
        name: nameRoutes.LOGIN,
      },
    ],
  },
  {
    path: "/",
    component: BaseLayout,
    beforeEnter: checkAuthorized,
    children: [
      {
        path: "/",
        redirect: { name: nameRoutes.RICHIESTE },
      },
      {
        path: "/index.html",
        redirect: { name: nameRoutes.RICHIESTE },
      },
      {
        path: "/benvenuto",
        component: Benvenuto,
        name: nameRoutes.BENVENUTO,
      },
      {
        path: "/richieste",
        component: Richieste,
        name: nameRoutes.RICHIESTE,
      },
      {
        path: "/richiesta/:idRichiesta",
        component: Richiesta,
        name: nameRoutes.RICHIESTA,
        props: true,
      },
      {
        path: "/richiesta/:idRichiesta/:idVassoioItem/:idPortata",
        component: Portata,
        name: nameRoutes.PORTATA,
      },
      { path: "*", component: NotFound },
    ],
  },
];

export default new VueRouter({
  mode: "history",
  routes,
  base: `/${getBasePath()}/`,
});
